import type { PaywallCheckoutPreview } from "@circle-react/types";

export const getNumberOfInstallments = (preview: PaywallCheckoutPreview) => {
  if (
    [
      "trial_then_value",
      "upfront_then_trial_then_value",
      "trial_then_upfront_then_value",
      "upfront_then_value",
    ].includes(preview.preview_scenario)
  ) {
    return 1 + (preview?.remaining_payments?.installments_preview?.length || 0);
  }

  // value
  return (
    1 +
    (preview.future_payments ? 1 : 0) +
    (preview?.remaining_payments?.installments_preview.length || 0)
  );
};

export const shouldExpandFuturePayments = (preview: PaywallCheckoutPreview) =>
  preview.future_payments &&
  (preview.future_payments.discount < 0 || preview.future_payments.tax > 0);
